import React from "react";
import { Link } from "react-router-dom";
// Assuming the image imports are relative to the final deployment path 
// or handled by a module bundler alias that resolves these names correctly.
import logoImg from "./logo-light-full (1).png";
import logoLightImg from "./logo-dark-original.png";

export interface MobileLogoProps {
    img?: string;
    imgLight?: string;
    className?: string;
}

const MobileLogo: React.FC<MobileLogoProps> = ({
    img = logoImg,
    imgLight = logoLightImg,
    // Set a smaller default class for mobile logo, e.g., w-24 (96px width)
    className = "w-36",
}) => {
    return (
        <Link
            to="/"
            className={`ttnc-logo inline-block text-primary-6000 focus:outline-none focus:ring-0 ${className}`}
        >
            {/* The images themselves should also have maximum height constraints for consistency */}
            {img ? (
                <img
                    className={`block max-h-16 ${imgLight ? "dark:hidden" : ""}`} // Reduced max-height for mobile
                    src={img}
                    alt="Logo"
                />
            ) : (
                "Mobile Logo Here"
            )}
            {imgLight && (
                <img
                    className="hidden max-h-16 dark:block" // Reduced max-height for mobile
                    src={imgLight}
                    alt="Logo-Light"
                />
            )}
        </Link>
    );
};

export default MobileLogo;